import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  createAccessControl,
  deleteAccessControl,
  getAccessControl,
  getAccessControls,
  getAccessControlsMasterData,
  updateAccessControl
} from '../../../api/access-controls';

export const getAccessControlsAsync = createAsyncThunk(
  'accessControls/getAccessControls',
  getAccessControls
);

export const getAccessControlsMasterDataAsync = createAsyncThunk(
  'accessControls/getAccessControlsMasterData',
  getAccessControlsMasterData
);

export const getAccessControlAsync = createAsyncThunk(
  'accessControls/getAccessControl',
  getAccessControl
);

export const createAccessControlAsync = createAsyncThunk(
  'accessControls/createAccessControl',
  createAccessControl
);

export const updateAccessControlAsync = createAsyncThunk(
  'accessControls/updateAccessControl',
  updateAccessControl
);

export const deleteAccessControlAsync = createAsyncThunk(
  'accessControls/deleteAccessControl',
  deleteAccessControl
);

export interface AccessControl {
  id: number;
  name: string;
  description: string;
}

interface AccessControlState {
  data: AccessControl[];
  masterData: AccessControl[];
  count: number;
  selectedAccessControl: AccessControl | null;
}

const initialState: AccessControlState = {
  data: [],
  masterData: [],
  count: 0,
  selectedAccessControl: null
};

export default createSlice({
  name: 'accessControls',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAccessControlsAsync.fulfilled, (state, action) => {
      state.data = action.payload.data;
    });
    builder.addCase(
      getAccessControlsMasterDataAsync.fulfilled,
      (state, action) => {
        state.masterData = action.payload.data;
        state.count = action.payload.count;
      }
    );
    builder.addCase(getAccessControlAsync.fulfilled, (state, action) => {
      state.selectedAccessControl = action.payload;
    });
  }
});
